import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-folder-open-icon',
  templateUrl: 'folder-open-icon.component.html'
})
export class FolderOpenIconComponent {
  constructor() {}
}
